export const normalizeDataIndex = (dataIndex: string | string[]): string =>
  typeof dataIndex === 'string' ? dataIndex : dataIndex?.join('__') || '';

export const getDefaultSortName = (dataIndex?: string | string[]): string => {
  const parts = Array.isArray(dataIndex)
    ? dataIndex
    : dataIndex
      ? [dataIndex]
      : [];
  const withoutDataPrefix = parts[0] === 'data' ? parts.slice(1) : parts;
  return withoutDataPrefix.join('.');
};
